<template>
  <div><router-view></router-view></div>
</template>

<script>
export default {
  name: "BlankLayout"
};
</script>

<style></style>
